import axios from 'axios';
import { getAuthConfig } from '../mixins/ApiConfig';

/** GET JSON by path with app auth — shared by TanStack queryFns. */
export function jsonGet(url) {
    return axios.get(url, getAuthConfig()).then((res) => res.data);
}

/** POST JSON with app auth — returns full response (status checks in mutations). */
export function jsonPost(url, body) {
    return axios.post(url, body, getAuthConfig()).then((res) => res);
}

/** PUT JSON with app auth — returns full response (status checks in mutations). */
export function jsonPut(url, body) {
    return axios.put(url, body, getAuthConfig()).then((res) => res);
}

/** DELETE with app auth — shared by TanStack mutations. */
export function jsonDelete(url) {
    return axios.delete(url, getAuthConfig()).then((res) => res.data);
}

/** DELETE with app auth — returns full response (status checks in mutations). */
export function jsonDeleteResponse(url) {
    return axios.delete(url, getAuthConfig()).then((res) => res);
}
